import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../../firebase";
import Skins from "./Skins";
import { AppContext } from "../../../context/context";

import { useContext, useState } from "react";
import Modal from "react-modal";

import Enlarge from "../../../images/Enlarge.svg";
import Username from "../../../images/Username.svg";
import Inbox from "../../../images/Inbox.svg";
import { Title } from "../../../stories/Title/Title";
import { Button } from "../../../stories/Button/Button";

import { Label } from "../../../stories/Label/Label";

import { CustomTooltip } from "../../../styles/TooltipStyles";

import {
  LogOutModalStyles,
  WaiveOffModalStyles,
} from "../../../styles/CustomModalStyles";
import { toggleFullSceen } from "../../../utils/UtilFunctions";
import Close from "../../../images/Close.svg";
import { TOOLTIP_COLORS } from "../../../styles/Variables";

import { payloadTypes } from "../../../context/reducer";
import FinYrAutocomplete from "../../../customComponents/FinancialYearAutocomplete";
import useEmpMasters from "../../../customHooks/useEmpMasters";
import HeaderName from "../../../customComponents/HeaderName";
import { empType } from "../../../utils/Enum.types";
import ChangePassword from "./ChangePassword";

export const handleSignOut = () => {
  localStorage.removeItem("authToken");
  signOut(auth)
    .then(() => (window.location.href = "/"))
    .catch((error) => {
      alert(error);
    });
};

const Header = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const [userLogout, setUserLogout] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const { data } = useEmpMasters(state.empId);

  return (
    <>
      <div className="header">
        <div className="row g-0 h-100">
          <div className="col h-100">
            <b>
              <HeaderName />
            </b>
          </div>
          <div className="col-5 h-100">
            <ul className="header__icon">
              {state.empSubType !== empType.SYS_ADMIN ? null : (
                <li className="header__icon--li">
                  <FinYrAutocomplete
                    label="Financial Year"
                    onChange={(newValue) => {
                      dispatch({
                        type: payloadTypes.SET_ACTIVE_FIN_YR,
                        payload: {
                          ActiveFinYr: newValue,
                        },
                      });
                    }}
                    value={state.ActiveFinYr ? state.ActiveFinYr.id : 0}
                  />
                </li>
              )}

              <li>
                <CustomTooltip
                  title="Full Screen"
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: TOOLTIP_COLORS.VARIABLE,
                        "& .MuiTooltip-arrow": {
                          color: TOOLTIP_COLORS.VARIABLE,
                        },
                      },
                    },
                  }}
                >
                  <img
                    src={Enlarge}
                    alt="/"
                    onClick={() => toggleFullSceen()}
                  />
                </CustomTooltip>
              </li>

              <li>
                <Skins />
              </li>
              {state.claims?.EDUATE ? (
                <li>
                  <CustomTooltip
                    title="Token"
                    arrow
                    placement="top"
                    className="tooltip-hide"
                    slotProps={{
                      tooltip: {
                        sx: {
                          bgcolor: TOOLTIP_COLORS.VARIABLE,
                          "& .MuiTooltip-arrow": {
                            color: TOOLTIP_COLORS.VARIABLE,
                          },
                        },
                      },
                    }}
                  >
                    <img
                      src={Inbox}
                      alt="/"
                      onClick={() => navigate("/token")}
                    />
                  </CustomTooltip>
                </li>
              ) : null}

              <li>
                <CustomTooltip
                  title="SignOut"
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: TOOLTIP_COLORS.VARIABLE,
                        "& .MuiTooltip-arrow": {
                          color: TOOLTIP_COLORS.VARIABLE,
                        },
                      },
                    },
                  }}
                  className="tooltip-hide"
                >
                  <img
                    src={Username}
                    alt="/"
                    onClick={() => setUserLogout(!userLogout)}
                  />
                </CustomTooltip>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Modal
        shouldCloseOnOverlayClick={true}
        isOpen={userLogout}
        ariaHideApp={false}
        style={LogOutModalStyles}
        onRequestClose={() => setUserLogout(!userLogout)}
      >
        <div className="logout-modal">
          <img src={Username} alt="/" />
          <Title variant="subtitle1">UserName</Title>
          <Title variant="subtitle2">{auth.currentUser?.email}</Title>

          <Label
            variant="LabelPrimary"
            onClick={() => {
              setPasswordModal(!passwordModal);
              setUserLogout(!userLogout);
            }}
          >
            Change Password
          </Label>

          <Button
            onClick={() => {
              setUserLogout(!userLogout);
              handleSignOut();
            }}
            mode="sign-out"
          />
        </div>
      </Modal>

      <Modal
        shouldCloseOnOverlayClick={true}
        isOpen={passwordModal}
        style={WaiveOffModalStyles}
        ariaHideApp={false}
      >
        <ChangePassword setPasswordModal={setPasswordModal} />
      </Modal>
    </>
  );
};

export default Header;
